<div class="custom-modal">
    <div class="header">
      <h1 mat-dialog-title>Detalhes do Lote</h1>
      <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <div *ngIf="isLoading"
          class="d-flex justify-content-center align-items-center"
          style="height: 170px;">
            <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
        </div>
        <div class="table-responsive" [hidden]="isLoading">
          <div>
            <table mat-table  [dataSource]="detalhesLoteGrid">
              <ng-container matColumnDef="nrt">
                <th mat-header-cell *matHeaderCellDef>NRT</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.nrt }}</td>
              </ng-container>
    
              <ng-container matColumnDef="doc">
                <th mat-header-cell *matHeaderCellDef>Documento</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.doc }}</td>
              </ng-container>
    
              <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.nome }}</td>
              </ng-container>
    
              <ng-container matColumnDef="cep">
                <th mat-header-cell *matHeaderCellDef>CEP</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.cep }}</td>
              </ng-container>
    
              <ng-container matColumnDef="datarecepcao">
                <th mat-header-cell *matHeaderCellDef>Data Recepção</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.datarecepcao | date: "dd/MM/yyyy - HH:mm:ss" }}</td>
              </ng-container>
    
              <ng-container matColumnDef="nmanifesto">
                <th mat-header-cell *matHeaderCellDef>Nº Manifesto</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.nmanifesto }}</td>
              </ng-container>
    
              <ng-container matColumnDef="datamanifesto">
                <th mat-header-cell *matHeaderCellDef>Data Manifesto</th>
                <td mat-cell *matCellDef="let detalhesLoteGrid">{{ detalhesLoteGrid.datamanifesto | date: "dd/MM/yyyy - HH:mm:ss" }}</td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <app-paginacao [hidden]="paging?.length <= 5"
            [pageIndex]="paging?.index"
            [pageSize]="paging?.size"
            [length]="paging?.length"
            (page)="onPageChange($event)"
            [pageSizeOptions]="[5]"></app-paginacao>

        </div>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
      <button *ngIf="!isLoading && detalhesLoteGrid.length" mat-flat-button type="button" color="success"
      (click)="downloadExcel()" [disabled]="isLoadingDownload">
      <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
      <mat-spinner diameter="20" color="dark"></mat-spinner>
      &nbsp; Baixando
      </span>
      <span *ngIf="!isLoadingDownload">
      <i class="fas fa-file-excel"></i> Download Excel
      </span>
      </button>
      <button mat-flat-button color="info" mat-dialog-close="cancel">
        Fechar
      </button>
    </div>
</div>

  